import ActionTypeServicio from "../ActionTypeServicio";

export default class FinalizarComando extends ActionTypeServicio {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
